var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7e5db8533a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145 394 L 657.777344 394 L 657.777344 622.90625 L 145 622.90625 Z M 145 394 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 128.519531 335.488281 L 95.882812 227.074219 C 91.734375 212.234375 100.03125 196.847656 114.277344 192.101562 C 129.117188 187.953125 144.511719 196.25 149.257812 210.488281 L 161.105469 250.753906 C 204.382812 177.261719 284.398438 127.503906 376.304688 127.503906 C 478.859375 127.503906 567.167969 190.304688 605.148438 279.230469 C 612.847656 297.566406 599.203125 318.300781 579.660156 318.300781 C 568.367188 318.300781 558.273438 311.804688 554.171875 301.714844 C 524.535156 231.820312 456.367188 183.207031 376.304688 183.207031 C 303.988281 183.207031 240.566406 223.476562 207.933594 282.777344 L 255.960938 268.539062 C 270.804688 264.394531 286.195312 272.6875 290.945312 286.925781 C 295.09375 301.714844 286.796875 317.152344 272.554688 321.847656 L 164.101562 354.472656 C 148.660156 358.617188 133.265625 350.324219 128.519531 335.488281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e5db8533a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 603.351562 539.375 L 591.507812 499.058594 C 548.226562 573.148438 468.164062 622.90625 376.304688 622.90625 C 273.753906 622.90625 185.441406 560.109375 147.460938 471.230469 C 139.765625 452.84375 153.40625 432.109375 172.949219 432.109375 C 184.242188 432.109375 194.289062 438.605469 198.488281 448.695312 C 228.125 518.640625 296.292969 567.203125 376.304688 567.203125 C 448.621094 567.203125 512.042969 526.933594 544.679688 467.683594 L 496.648438 481.871094 C 481.808594 486.015625 466.414062 477.722656 461.664062 463.535156 C 457.519531 448.695312 465.8125 433.308594 480.058594 428.5625 L 588.558594 395.9375 C 603.351562 391.792969 618.792969 400.085938 623.542969 414.925781 L 656.675781 523.386719 C 660.824219 538.175781 652.578125 553.613281 638.335938 558.359375 C 623.542969 562.507812 607.5 554.210938 603.351562 539.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.45e9f9e199679d299628d7daf8bcdf4d.svg";
export { ForwardRef as ReactComponent };